// extracted by mini-css-extract-plugin
export var arrowContainer = "header-generic-module--arrowContainer--c4cc4";
export var breadcrumb = "header-generic-module--breadcrumb--4282c";
export var contactButton = "header-generic-module--contactButton--692cc";
export var contactButtonDark = "header-generic-module--contactButtonDark--73d4c";
export var contactContainer = "header-generic-module--contactContainer--91f0d";
export var contactLink = "header-generic-module--contactLink--0f5cc";
export var header = "header-generic-module--header--60c1d";
export var headerContent = "header-generic-module--headerContent--85033";
export var headerDark = "header-generic-module--headerDark--e6aa3";
export var homeBtn = "header-generic-module--homeBtn--27b2b";
export var homeBtnDark = "header-generic-module--homeBtnDark--a2964";
export var homeBtnSvg = "header-generic-module--homeBtnSvg--d6308";
export var homeBtnText = "header-generic-module--homeBtnText--0c0f5";
export var icon = "header-generic-module--icon--1fef5";
export var iconCircle = "header-generic-module--iconCircle--31743";
export var iconCircleDark = "header-generic-module--iconCircleDark--7153a";
export var iconContainer = "header-generic-module--iconContainer--48a86";
export var langSelector = "header-generic-module--langSelector--3314d";
export var langSelectorDark = "header-generic-module--langSelectorDark--96d80";
export var link = "header-generic-module--link--14680";
export var linkBtn = "header-generic-module--linkBtn--601ad";
export var linkBtnDark = "header-generic-module--linkBtnDark--5772d";
export var linkBtnSvg = "header-generic-module--linkBtnSvg--1e1d5";
export var linkElement = "header-generic-module--linkElement--60102";
export var linksContainer = "header-generic-module--linksContainer--e5243";
export var menuContainer = "header-generic-module--menuContainer--2ce53";
export var menuContent = "header-generic-module--menuContent--239fb";
export var moveArrow = "header-generic-module--moveArrow--049d4";
export var reversedArrow = "header-generic-module--reversedArrow--59c18";
export var searchBarContainer = "header-generic-module--searchBarContainer--89666";
export var searchModuleContent = "header-generic-module--searchModuleContent--19a59";
export var websiteSettingsAndSearch = "header-generic-module--websiteSettingsAndSearch--1c181";